export default {
    adjustments: {
        title: "Säädökset",
        reset: "Nollaa",
        light: {
            title: "Valo",
            brightness: "Kirkkaus",
            contrast: "Kontrasti",
            shadows: "Varjot",
        },
        color: {
            title: "Väri",
            saturation: "kyllästyminen",
            temperature: "Lämpötila",
            blacks: "Mustat",
            whites: "Valkoiset",
        },
        detail: {
            title: "Yksityiskohta",
            clarity: "Kirkkaus",
            sharpness: "Terävyys",
            blur: "Sumea",
        },
    },
};
